let env = process.env.REACT_APP_ENV;

const appConfig = {
  apiPrefix:
    env === "dev"
      ? "https://student-api.tst.applyform.io/api"
      : env === "tst"
      ? "https://student-api.tst.applyform.io/api"
      : env === "multi-tenant"
      ? "https://student-api.tst.applyform.io/api"
      : "http://localhost:8080/api",
  authenticatedEntryPath: "/app/user-feed",
  unAuthenticatedEntryPath: "/sign-in",
  publicRoute: "/",
  enableMock: true,
  appBackendUrl:
    env === "dev"
      ? "https://student-api.tst.applyform.io/api/"
      : env === "tst"
      ?"https://student-api.tst.applyform.io/api/"
      : env === "multi-tenant"
      ? "https://student-api.tst.applyform.io/api/"
      : "http://localhost:8080/",
};

export default appConfig;
